<template lang="pug">
	content-page
		div(slot="nav")
			navigation-default
		.flow-left
			h1 {{contentpage.name}}
			ws-content(:value="contentpage.content")
				v-divider.mb-6
				v-row
					v-col
						h2 {{$t('page.podcast:wintersport.podcast.title')}}
						v-row(v-for="item in wintersportEpisodes" :key="item.id")
							v-col
								h3 {{item.title}}
								small.cl-gray.light {{$t('page.podcast:published.at.{date}', {date: $dayjs(item.publishDate).format('DD MMM YYYY')})}}
								vue-plyr.my-6(ref='plyr' :options='{"controls":["play", "progress", "volume", "play-large", "airplay", "fullscreen", "pip", "mute"], "disableContextMenu": false}' :key="item.youtubeId")
									div(data-plyr-provider='youtube' :data-plyr-embed-id='item.youtubeId')
								h4 {{$t('page.podcast:show.notes')}}
								ws-content(:markdown="item.content.markdown" level="5")
					v-col
						h2 {{$t('page.podcast:resort.podcast.title')}}
						v-row(v-for="item in resortEpisodes" :key="item.id")
							v-col
								h3 {{item.title}}
								small.cl-gray.light {{$t('page.podcast:published.at.{date}', {date: $dayjs(item.publishDate).format('DD MMM YYYY')})}}
								vue-plyr.my-6(ref='plyr' :options='{"controls":["play", "progress", "volume", "play-large", "airplay", "fullscreen", "pip", "mute"], "disableContextMenu": false}' :key="item.youtubeId")
									div(data-plyr-provider='youtube' :data-plyr-embed-id='item.youtubeId')
								h4 {{$t('page.podcast:show.notes')}}
								ws-content(:markdown="item.content.markdown" level="5")

</template>

<script>
import gql from 'graphql-tag';
import NavigationDefault from '@/components/navigation-default';
import MetaFragment from '@/components/graphql/metaFragment.graphql';

const query = gql`
	query getPodcastPage($slug: String!) {
		contentpage(slug: $slug) {
			id
			name
			slug
			content {
				markdown
			}
			...MetaFragment
		}
		podcastEpisodes {
			id
			title
			publishDate
			type
			url
			youtubeId
			content {
				markdown(level: 5)
			}
		}
	}
	${MetaFragment}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/podcast',
			'nl-BE': '/podcast'
		}
	},
	components: { NavigationDefault },
	asyncData({ _params, app, route }) {
		app.ads({});

		return app.$graphClient
			.query({
				query,
				variables: { slug: route.path.split('/').pop() },
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (errors) {
					throw errors[0];
				}

				app.meta(data.contentpage.meta);
				app.breadcrumbs({
					[data.contentpage.name]: { name: 'podcast' }
				});

				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'podcast-01', error);
			});
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	computed: {
		wintersportEpisodes() {
			return this.podcastEpisodes.filter(
				episode => episode.type === 'wintersport'
			);
		},
		resortEpisodes() {
			return this.podcastEpisodes.filter(episode => episode.type === 'resort');
		}
	}
};
</script>
